// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".f97d5378c5bf72018fcae4aae196b9bd.js";
};